import React from 'react';
import Image from 'next/image'
import Link from 'next/link'
import MoreBtn from '@/components/comman/MoreBtn'
import Recognition from '@/components/Recognition'
import Testimonial from '@/components/comman/Testimonial'
import BookaCall from '@/components/comman/BookaCall'
import StartaProject from '@/components/StartaProject'
import { GetStaticPaths, GetStaticProps } from 'next';
import { getSingleIndustrieData, getIndustriesListingData } from '../../lib/industries';
import { geindustriesSeoData  } from '../../lib/seo';
import SEO from '@/components/SEO'
import CountUp from 'react-countup';
import IndustriesForm from '@/components/IndustriesForm';
function IndustrieSingle({initialIndustrie, initialSeo, initialIndustriesListing}:any) {

    
    const banner = initialIndustrie?.node?.industries?.bannerIndustrie
    const fuulyCustom = initialIndustrie?.node?.industries?.fullyCustom
    const sinces = initialIndustrie?.node?.industries?.sinceIndustrie
    const bookCallData = initialIndustrie?.node?.industries?.bookACall
    const industrieContentArea1 = initialIndustrie?.node?.industries?.industrieContentArea1
    const industrieContentArea2 = initialIndustrie?.node?.industries?.industrieContentArea2
    const selectProject1 = initialIndustrie?.node?.industries?.selectProject1
    const selectProject2 = initialIndustrie?.node?.industries?.selectProject2
    const faqsData = initialIndustrie?.node?.industries?.faqs
    const industrieContentArea3 = initialIndustrie?.node?.industries?.contentArea3
  
  return (
    <div className='insustrie_single_page'>
        <SEO initialSeo={initialSeo}/>
        <section className='full_banner'>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="left_banner">
                            <div className="caption">
                                <span className='sub_heading' data-aos="fade-right" data-aos-delay="100">{banner?.bannerSubTitle}</span>
                                <h1 data-aos="fade" data-aos-delay="100">{banner?.bannerTitle}</h1>
                                <p data-aos="fade" data-aos-delay="200">
                                    {banner?.bannerDescription}
                                </p>
                                {/* <Link href={`${banner?.bannerButton?.url}`} className="cmn_btn_fill" data-aos="fade-up" data-aos-delay="100">
                                    <span>{banner?.bannerButton?.title}</span>
                                </Link> */}
                                {banner?.bannerButton?.url && (
                                <Link href={banner.bannerButton.url} className="cmn_btn_fill" data-aos="fade-up" data-aos-delay="100">
                                    <span>{banner.bannerButton.title}</span>
                                </Link>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="right_banner">
                            <div className="right_img" data-aos="fade-left" data-aos-delay="100">
                                <Image src={banner?.bannerImage?.sourceUrl} alt={banner?.bannerImage?.altText} width={1180} height={939} loading="lazy"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MoreBtn sectionId="whatwedo"/>
        </section>
        <section id="whatwedo" className="section whatwedo">
            <div className="container">
                <span className="sub_heading" data-aos="fade-right" data-aos-delay="100">{fuulyCustom?.subTitle}</span>
                <div className="row">
                    <div className="col-lg-3">
                        <div className="wwd_left">
                        <h2 data-aos="fade" data-aos-delay="100">{fuulyCustom?.title}</h2>
                        <p data-aos="fade" data-aos-delay="200">
                            {fuulyCustom?.description}
                        </p>
                        <div className="whatwedo_btns">
                            {
                                fuulyCustom?.ctaButton?.url && (
                                    <Link href={`${fuulyCustom?.ctaButton?.url}`} className="cmn_btn_fill" data-aos="fade-down" data-aos-delay="100">
                                        <span> {fuulyCustom?.ctaButton?.title}</span>
                                    </Link>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="col-lg-7 offset-lg-2"> 
                    <div className="">
                    <div className="row gx-5">
                        {
                            fuulyCustom?.industriesServices && fuulyCustom?.industriesServices.map((industrie:any,index:any)=>{
                                return(
                                    <div key={index} className="col-xl-4 col-md-6" data-aos="fade" data-aos-delay="100">
                                        <div className="www_box mTop">
                                            <Link href={`${industrie?.slug}`}>
                                                <h3 className="f24 fw-800">{industrie?.title}</h3>
                                            </Link>
                                            <div className="ind_excerpt" dangerouslySetInnerHTML={{ __html: industrie?.excerpt || '' }}></div>
                            
                                        </div>
                                    </div>
                                )
                            })

                        }
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <section className='since'>
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <div className="col-lg-6 p-0">
                        <div className="since_left white">
                            <div className="since_content" dangerouslySetInnerHTML={{ __html: sinces?.sinceContent || '' }}></div>
                            {sinces?.sinceButton?.url && (
                            <Link href={`${sinces?.sinceButton?.url}`} className='cmn_btn' data-aos="fade-down" data-aos-delay="100">
                                <span>{sinces?.sinceButton?.title}</span>
                            </Link>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-6 p-0">
                        <div className="since_right">
                            <div className="since_list">
                                {/* {
                                    sinces?.sinces && sinces?.sinces.map((since:any,index:any)=>{
                                        return(
                                            <div key={index} className="since_box" data-aos="fade-left" data-aos-delay="100">
                                                <h3> <CountUp enableScrollSpy={true} end={since?.sinceData} /></h3>
                                                
                                                <div className="seperator"><span></span></div>
                                                <p>{since?.sinceTitle}</p>
                                            </div>
                                        )
                                    })
                                } */}
                                {
                                sinces?.sinces && sinces?.sinces.map((since:any,index:any)=>{
                                    let endValue;
                                    let sign = '';
                                    if (typeof since.sinceData === 'string' && since.sinceData.endsWith('%')) {
                                        endValue = parseFloat(since.sinceData);
                                        sign = '%';
                                    } else if (!isNaN(Number(since.sinceData))) {
                                        endValue = Number(since.sinceData);
                                    } else {
                                        endValue = since.sinceData;
                                    }

                                    return (
                                        <div key={index} className="since_box" data-aos="fade-left" data-aos-delay="100">
                                            {typeof endValue === 'number' ? (
                                                <h3><CountUp enableScrollSpy={true} end={endValue} />{sign}</h3>
                                            ) : (
                                                <h3>{endValue}</h3>
                                            )}
                                            <div className="seperator"><span></span></div>
                                            <p>{since?.sinceTitle}</p>
                                        </div>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       <Recognition/>
       <Testimonial/>
       <BookaCall data={bookCallData}/>
       {industrieContentArea1 && (
            <section className='section'>
                <div className="container">
                    <div className="full_content" data-aos="fade" data-aos-delay="200">
                        <div className="default_typo" dangerouslySetInnerHTML={{ __html: industrieContentArea1 || '' }}></div>
                    </div>
                </div>
            </section>
        )}
        <section>
            <div className="zig50 reverse without_screen">
                <div className="zig50_left" style={{backgroundImage: `url('${selectProject1?.projects?.projectsBackgroundImage?.sourceUrl}`}}>
                    {/* <div className="zig50_center">
                        <div className="laptop" data-aos="fade-left" data-aos-delay="100">
                            <Image src="/images/macbookpro.png" alt="macbookpro  apple" width={1263} height={831}  loading="lazy"/>
                            <div id="macScreen" style={{backgroundImage: `url('${selectProject1?.projects?.projectImage?.sourceUrl}')`}}></div>
                        </div>
                    </div> */}
                    <div className="without_screen_img">
                        <Image src={selectProject1?.projects?.projectImage?.sourceUrl || '/images/placeholder.jpg'} alt={selectProject1?.title || 'placeholder'} width={1067} height={653}/>
                    </div>
                </div>
                <div className="zig50_right">
                    <div className="zig50_content">
                      <div className="zig50_wrap">
                            <h2 data-aos="fade" data-aos-delay="100">{selectProject1?.title}</h2>
                            <div className="indProjectContent" dangerouslySetInnerHTML={{ __html: selectProject1?.content || '' }}></div>
                            {selectProject1?.slug && (
                            <Link href={`/our-works/${selectProject1?.slug}`} className='cmn_btn' data-aos="fade-down" data-aos-delay="100">
                                <span>View project</span>
                            </Link>
                            )}
                      </div>
                    </div>
                </div>
            </div>
        </section>
        {industrieContentArea2 && (
            <section className='section'>
                <div className="container">
                    <div className="full_content" data-aos="fade" data-aos-delay="200">
                        <div className="default_typo" dangerouslySetInnerHTML={{ __html: industrieContentArea2 || '' }}></div>
                    </div>
                </div>
            </section>
        )}
        <section>
            <div className="zig50">
                <div className="zig50_left" style={{backgroundImage: `url('${selectProject2?.projects?.projectsBackgroundImage?.sourceUrl}')`}}>
                    <div className="nImg" data-aos="fade-right" data-aos-delay="100">
                        <Image src={selectProject2?.projects?.projectImage?.sourceUrl} alt={selectProject2?.projects?.projectImage?.altText} width={1398} height={1007} loading="lazy" />
                    </div>
                </div>
                <div className="zig50_right">
                    <div className="zig50_content">
                      <div className="zig50_wrap">
                            <h2 data-aos="fade" data-aos-delay="100">{selectProject2?.title}</h2>
                            <div className="indProjectContent" dangerouslySetInnerHTML={{ __html: selectProject2?.content || '' }}></div>
                            {selectProject2?.slug && (
                            <Link href={`/our-works/${selectProject2?.slug}`} className='cmn_btn' data-aos="fade-down" data-aos-delay="100">
                                <span>View project</span>
                            </Link>
                            )}
                      </div>
                    </div>
                </div>
            </div>
        </section>
        {!faqsData.hideFaqSection && faqsData.title && faqsData.description && (
        <section className="section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <span className="sub_heading" data-aos="fade-right" data-aos-delay="100">{faqsData?.subTitle}</span>
                        <h2 data-aos="fade" data-aos-delay="100">
                           {faqsData?.title}
                        </h2>
                        <p data-aos="fade" data-aos-delay="200">
                           {faqsData?.description}
                        </p>
                    
                    </div>
                    <div className="col-lg-8 offset-lg-1">
                        <div className="section_right" data-aos="fade-left" data-aos-delay="100">
                            <div className="accordion" id="accordionExample">
                                {
                                    faqsData?.faqs && faqsData?.faqs.map((faq:any, index:any) => {
                                        return (
                                        <div key={index} className="accordion-item">
                                            <h2 className="accordion-header">
                                            <button className={`accordion-button ${index === 0 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#faq${index + 1}`} aria-expanded={index === 0 ? 'true' : 'false'} aria-controls={`faq${index + 1}`}>
                                                {faq?.question}
                                            </button>
                                            </h2>
                                            <div id={`faq${index + 1}`} className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} aria-labelledby={`faq${index + 1}`} data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <p>{faq?.answer}</p>
                                            </div>
                                            </div>
                                        </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        )}
 
        {
            industrieContentArea3 &&(
                <section className="section next_section">
                    <div className="container">
                        <div className="full_content" data-aos="fade" data-aos-delay="200">
                            <div className="default_typo" dangerouslySetInnerHTML={{ __html: industrieContentArea3 || '' }}></div>
                        </div>
                    </div>
                </section>
            )
        }
        <section className='section'>
            <div className="container">
                <div className="ind_form">
                    <IndustriesForm  initialIndustriesListing={initialIndustriesListing}/>
                </div>
            </div>
        </section>
        <StartaProject/>
    </div>
  )
}

export default IndustrieSingle

export const getStaticPaths: GetStaticPaths = async () => {
    // Fetch all services and generate paths for each service's slug
    const industries = await getSingleIndustrieData();
    const paths = industries.map((industrie: any) => ({
      params: { slug: industrie.node.slug },
    }));
  
    return { paths, fallback: false }; // fallback: false means other routes should 404
  };
    
    // This function gets the data for each individual service page
export const getStaticProps: GetStaticProps = async ({ params }: any) => {
    const slug = params.slug;
    const initialIndustriesListing = await getIndustriesListingData()
    const initialIndustries = await getSingleIndustrieData();
    const initialSeo = await geindustriesSeoData(slug)
    const initialIndustrie = initialIndustries.find((s: any) => s.node.slug === slug);
    return { props: { initialIndustrie, initialIndustriesListing, initialSeo } };
    
};
